/**
 * @description Open the workbook worker. Webpack turns this URL into its own bundle.
 * @returns {Worker}
 */
export function createReportWorkbookWorker() {
    return new Worker(new URL('./reportWorkbook.worker.js', import.meta.url));
}
